import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL
const APP_URL = process.env.VUE_APP_APP_URL

// const API_URL = 'http://mic.intowin.es/api/';
// const APP_URL = 'http://mic.intowin.es/';

export class Api{

	constructor(){}

	login(params){
		const url = API_URL + "volunteer/login";
		var self = this;
		const oParams = new URLSearchParams();
		Object.keys( params ).forEach( key => {
			oParams.append( key , params[ key ] );
		});

		/*return axios({
			method: 'post',
			url: url+ '?nocache=' + new Date().getTime(),
			withCredentials: true,
			data: oParams
		}).then(response => {
			console.log( response );
			if( response.status == 200 )
				return response.data;
		});*/
		
		return axios.post(url+ '?nocache=' + new Date().getTime(), oParams, { withCredentials: true } ).then(function (response) {
			if( response.status == 200 )
				return response.data;
		});
	}

	get(uri) {
        axios.defaults.headers.common['Authorization'] = localStorage.token

		const url = API_URL+uri;
		var self = this;
	    return axios.get(url, {
			withCredentials: true,
			validateStatus: function( status ){
				if( status == 403 ){
					window.location.href = APP_URL + "login";
				}
				return true;
			}
		} ).then(function (response) {
			return response.data;
  		});
	}

	post(uri, params) {
        axios.defaults.headers.common['Authorization'] = localStorage.token

		const oParams = new URLSearchParams();
		Object.keys( params ).forEach( key => {
			oParams.append( key , params[ key ] );
		});
		
		const url = API_URL+uri;
		return axios.post(url, oParams,
			{ 
				withCredentials: true,
				validateStatus: function( status ){
					if( status == 403 ){
						window.location.href = APP_URL + "login";
					}
					return true;
				}

			} 
		).then(function (response) {
			return response.data;
		})	
	}

	import(uri, params) {
        axios.defaults.headers.common['Authorization'] = localStorage.token

		const url = API_URL+uri;
		return axios.post(url, params,
			{ 
				withCredentials: true,
				validateStatus: function( status ){
					if( status == 403 ){
						window.location.href = APP_URL + "login";
					}
					return true;
				}

			} 
		).then(function (response) {
			return response.data;
		})	
	}

	language(lang) {
        axios.defaults.headers.common['Authorization'] = localStorage.token
        
		const url = API_URL + 'volunteer/language/' + lang;
		var self = this;
	    return axios.get(url, {
			withCredentials: true,
			validateStatus: function( status ){
				if( status == 403 ){
					window.location.href = APP_URL + "login";
				}
				return true;
			}
		} ).then(function (response) {
			//console.log( response.data );
			return response.data;
  		});
	}

}